import styles from "./settings-page.module.css"

export default function SettingsPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>系统设置</h1>

      <div className={styles.sections}>
        {/* 基本设置 */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>基本设置</h2>
          <div className={styles.formGroup}>
            <label className={styles.label}>平台名称</label>
            <input type="text" defaultValue="蓝血精英" className={styles.input} />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>平台 Logo</label>
            <div className={styles.logoUpload}>
              <span className={styles.logoPreview}>🔵</span>
              <button className={styles.uploadBtn}>上传图片</button>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>联系邮箱</label>
            <input type="email" defaultValue="contact@example.com" className={styles.input} />
          </div>
        </div>

        {/* 费用设置 */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>费用设置</h2>
          <div className={styles.formGroup}>
            <label className={styles.label}>平台抽成比例 (%)</label>
            <input type="number" defaultValue="15" className={styles.input} />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>最低提现金额 (¥)</label>
            <input type="number" defaultValue="100" className={styles.input} />
          </div>
        </div>

        {/* 通知设置 */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>通知设置</h2>
          <div className={styles.formGroup}>
            <label className={styles.checkbox}>
              <input type="checkbox" defaultChecked />
              <span>新用户注册通知</span>
            </label>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.checkbox}>
              <input type="checkbox" defaultChecked />
              <span>大额提现审核通知</span>
            </label>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.checkbox}>
              <input type="checkbox" defaultChecked />
              <span>任务异常通知</span>
            </label>
          </div>
        </div>

        {/* 保存按钮 */}
        <div className={styles.actions}>
          <button className={styles.cancelBtn}>取消</button>
          <button className={styles.saveBtn}>保存设置</button>
        </div>
      </div>
    </div>
  )
}